// The widths are resized copies next to the original in public/: "/logo.png" at 120px is "/logo-120w.png".
export const responsiveImage = (path: string, widths: number[]) => {
  const atWidth = (width: number) => path.replace(/(\.\w+)$/, `-${width}w$1`);

  return {
    src: atWidth(widths[widths.length - 1]),
    srcSet: widths.map((width) => `${atWidth(width)} ${width}w`).join(","),
  };
};
